import React, { useState } from 'react'
import { Typography, theme, Badge, Dropdown, Menu, Button } from 'antd'
import { BarChartOutlined, BellOutlined, ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons'

const { Title } = Typography

const DashboardHeader = ({ alerts }) => {
  const { token } = theme.useToken()
  const [notificationsVisible, setNotificationsVisible] = useState(false)

  const criticalAlerts = alerts ? alerts.filter((alert) => alert.type === 'critical') : []
  const warningAlerts = alerts ? alerts.filter((alert) => alert.type === 'warning') : []
  const totalAlerts = criticalAlerts.length + warningAlerts.length

  const notificationMenu = (
    <Menu
      style={{
        width: 320,
        maxHeight: 400,
        overflow: 'auto',
        backgroundColor: '#fff',
        boxShadow: '0 3px 6px rgba(0,0,0,0.15)'
      }}
      onClick={() => setNotificationsVisible(false)}
    >
      <Menu.Item key='header' disabled style={{ fontWeight: 'bold', color: '#1f1f1f', backgroundColor: '#fafafa' }}>
        Recent Notifications ({totalAlerts})
      </Menu.Item>
      <Menu.Divider />

      {criticalAlerts.map((alert) => (
        <Menu.Item key={`critical-${alert.id}`} icon={<ExclamationCircleOutlined style={{ color: '#f5222d' }} />}>
          <div>
            <div style={{ fontWeight: 'bold', color: '#cf1322' }}>{alert.message}</div>
            <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{alert.time}</div>
          </div>
        </Menu.Item>
      ))}

      {warningAlerts.map((alert) => (
        <Menu.Item key={`warning-${alert.id}`} icon={<WarningOutlined style={{ color: '#faad14' }} />}>
          <div>
            <div style={{ fontWeight: 'bold', color: '#d48806' }}>{alert.message}</div>
            <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{alert.time}</div>
          </div>
        </Menu.Item>
      ))}

      <Menu.Divider />
      <Menu.Item key='view-all'>
        <Button type='link' style={{ padding: 0, height: 'auto', color: '#1890ff' }}>
          View all notifications
        </Button>
      </Menu.Item>
    </Menu>
  )

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        position: 'relative'
      }}
    >
      <div style={{ width: '40px' }}></div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <BarChartOutlined style={{ marginRight: '8px', fontSize: '24px', color: token.colorPrimary }} />
        <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
          Hospital Dashboard
        </Title>
      </div>

      <Dropdown
        overlay={notificationMenu}
        placement='bottomRight'
        arrow
        trigger={['click']}
        visible={notificationsVisible}
        onVisibleChange={setNotificationsVisible}
      >
        <Badge count={totalAlerts} size='small' offset={[-2, 3]}>
          <Button
            icon={<BellOutlined style={{ fontSize: '24px' }} />}
            style={{
              border: 'none',
              background: 'transparent',
              boxShadow: 'none',
              display: 'flex',
              alignItems: 'center',
              height: '32px'
            }}
          />
        </Badge>
      </Dropdown>
    </div>
  )
}

export default DashboardHeader
